import * as MUTATION_TYPES from "./mutation-types";
import * as GETTER_TYPES from "./getter-types";
import * as ACTION_TYPES from "./action-types"
import router from '../../router/index';

export const stepperState = {
  stepper: {
    loading: false,
    steps: [
      {
        id: 1,
        name: "detalles",
        active: true,
        completed: false
      },
      {
        id: 2,
        name: "extras",
        active: false,
        completed: false
      },
      {
        id: 3,
        name: "datos",
        active: false,
        completed: false
      }
    ],
  }
};

export const stepperGetters = {
  [GETTER_TYPES.GET_STEPPER](state) {
    return state.stepper;
  },
  [GETTER_TYPES.GET_ACTIVE_STEP](state) {
    return state.stepper.steps.find(step => step.active);
  }
};

export const stepperMutations = {
  [MUTATION_TYPES.SET_STEPPER](state, payload) {
    state.stepper = payload;
  },
  [MUTATION_TYPES.RESET_STEPPER](state, payload) {
    state.stepper.steps.forEach(step => {
      step.active = step.id === 1
      step.completed = false;
    });
  },
  [MUTATION_TYPES.SET_STEPPER_LOADING](state, payload) {
    state.stepper.loading = payload;
  },
  [MUTATION_TYPES.NEXT_STEP](state, payload) {
    const currentStep = state.stepper.steps.find(step => step.active);
    currentStep.completed = true;
    if (currentStep.id === 3) {
      router.push({name: 'booking-confirmation', params: {id: router.currentRoute.params.id}});
    } else {
      state.stepper.steps.forEach(step => {
        if (step.id === currentStep.id + 1) {
          step.active = true;
          router.replace({name: 'checkout', params: {step: step.name}, query: router.currentRoute.query });
        } else {
          step.active = false;
        }
      });
    }
  },
  [MUTATION_TYPES.GO_TO_STEP](state, payload) {
    state.stepper.steps.forEach(step => {
      if( step.id === payload ) {
        step.active = true;
        router.replace({name: 'checkout', params: {step: step.name}, query: router.currentRoute.query });
      } else {
        step.active = false;
      }
    });
  },
};

export const stepperActions = {
  [ACTION_TYPES.SET_STEPPER_LOADING]({ commit, state }, payload) {
    commit(MUTATION_TYPES.SET_STEPPER_LOADING, payload);
  },
  [ACTION_TYPES.RESET_STEPPER]({ commit, state }, payload) {
    commit(MUTATION_TYPES.RESET_STEPPER, payload);
  },
  [ACTION_TYPES.NEXT_STEP]({ commit, state }, payload) {
    commit(MUTATION_TYPES.NEXT_STEP, payload);
  },
  [ACTION_TYPES.GO_TO_STEP]({ commit, state }, payload) {
    commit(MUTATION_TYPES.GO_TO_STEP, payload);
  },
}
